import { render, staticRenderFns } from "./CustomerLookup.vue?vue&type=template&id=c128198c&scoped=true&"
import script from "./CustomerLookup.vue?vue&type=script&lang=js&"
export * from "./CustomerLookup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c128198c",
  null
  
)

export default component.exports